import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

const G = ({ title, children }) => (
  <div className="rounded-2xl border border-zinc-200 bg-white p-5">
    <h3 className="font-display font-bold text-zinc-900">{title}</h3>
    <p className="mt-1.5 text-sm text-zinc-600">{children}</p>
  </div>
);

export default function CreatorGuidelines() {
  return (
    <LegalLayout
      metaTitle="Creator Guidelines — Nearfluence"
      metaDescription="How creators should present themselves and collaborate on Nearfluence: accurate profiles, authentic metrics, professional communication, disclosure and safety."
      title="Creator Guidelines"
      subtitle="A few simple principles that keep Nearfluence trusted and fair for everyone."
    >
      <Section>
        <div className="grid gap-4 sm:grid-cols-2">
          <G title="Accurate profiles">Provide accurate and current information about yourself, your social accounts, audience and content.</G>
          <G title="Authentic metrics">Do not knowingly provide false follower counts, engagement information, audience statistics or other misleading information.</G>
          <G title="Professional communication">Communicate respectfully and professionally with businesses.</G>
          <G title="Collaboration commitments">Only accept opportunities you genuinely intend and are reasonably able to complete.</G>
          <G title="Advertising disclosure">You are responsible for ensuring your content complies with applicable advertising, consumer protection and platform rules, including clearly identifying advertising or sponsored content where required.</G>
          <G title="Content rights">Only upload or provide content you own or have permission to use.</G>
          <G title="Safety">Use appropriate judgement when arranging in-person collaborations, and report suspicious behaviour to Nearfluence.</G>
        </div>
      </Section>
    </LegalLayout>
  );
}
